<h1 mat-dialog-title >Retorno de equipo</h1>
<div class="container">
  <mat-card-content style="width: 70%;margin: auto">
    <form [formGroup]="equipoForm">

      <div formGroupName="equipo" style="display: flex;flex-wrap: wrap;justify-content: space-around">

        <div  style="display: flex;flex-wrap: wrap;flex-direction: column;width: 40%" >
          <mat-form-field appearance="outline" >
            <mat-label>Nombre</mat-label>
            <input matInput placeholder="Nombre" formControlName="nombre" name="nombre" required>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Categoría</mat-label>
            <input matInput placeholder="Categoría"formControlName="categoria" name="categoria" required>
          </mat-form-field>

          <mat-form-field appearance="outline" >
            <mat-label>Marca</mat-label>
            <input matInput placeholder="Marca" formControlName="marca" name="marca" required>
          </mat-form-field>

          <mat-form-field appearance="outline">
            <mat-label>Talla</mat-label>
            <input matInput placeholder="Talla"formControlName="talla" name="talla" required>
          </mat-form-field>

          <mat-form-field appearance="outline" >
            <mat-label>Modelo</mat-label>
            <input matInput placeholder="Modelo" formControlName="modelo" name="modelo" required>
          </mat-form-field>

        </div>

        <div style="display: flex;flex-wrap: wrap;flex-direction: column;width: 40%" >
          <mat-form-field appearance="outline">
            <mat-label>Estado</mat-label>
            <mat-select [(value)]="selectedEstado" >
              <mat-option *ngFor="let estado of arrayEstado" value={{estado}}>{{estado}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Seleccione la opción de valoración</mat-label>
            <mat-select formControlName="valoracion" placeholder="Seleccione la opción de valoración" required>
              <mat-option *ngFor="let option of validationOptions" [value]="option.value">{{ option.label }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Observaciones</mat-label>
            <textarea matInput placeholder="Observaciones" formControlName="observaciones" name="observaciones" cols="40" rows="5" ></textarea>
          </mat-form-field>
        </div>



      </div>



      <mat-dialog-actions align="center">
        <button mat-raised-button mat-dialog-close>Cancelar</button>
        <button mat-raised-button style="background-color: #e95a1a;color: white" (click)="updateEquipo()">Modificar Equipo</button>
      </mat-dialog-actions>

    </form>
  </mat-card-content>
</div>
